import styled from 'styled-components';
import { Captions, ShortBody } from 'components/Typography';
import { Grid } from '@material-ui/core';
import { REFUND_STATUSES } from 'constants/amcStatuses';
import breakpoints from 'utils/breakpoints';

export const StyledCaption = styled(Captions)`
  && {
    color: #9797af;
    font-size: 13px !important;
    margin: 1px !important;
  }
`;
export const StyledShortBody = styled(ShortBody)`
  && {
    font-weight: 500;
    margin-bottom: 0;
  }
`;
export const StyledLink = styled.a`
  && {
    text-decoration: none;
  }
`;

export const AlignedGrid = styled(Grid)`
  align-self: center;
`;

export const SizedGrid = styled(Grid)`
  min-height: 200px;
`;

export const StyledShortBody14 = styled(ShortBody)`
  && {
    color: #9797af;
    font-size: 14px !important;
    margin-top: 5px !important;
  }
`;

export const COLOR_BY_REFUND_STATUS: any = {
  [REFUND_STATUSES.RETURN]: '#fcb718',
  [REFUND_STATUSES.VISITE]: '#fcb718',
  [REFUND_STATUSES.AGREEMENT]: '#6fad37',
  [REFUND_STATUSES.REJECTED]: '#D0021B',
  [REFUND_STATUSES.PAIED]: '#6fad37',
  [REFUND_STATUSES.PEC_CANCELED]: '#D0021B',
  [REFUND_STATUSES.PENDING]: '#fcb718',
  [REFUND_STATUSES.COMPLEMENTARY_INFO]: '#fcb718',
  [REFUND_STATUSES.PEC]: '#fcb718',
  [REFUND_STATUSES.S_SUITE]: '#D0021B',
  DEFAULT: '#fcb718',
};

export const StyledDropZoneContainer = styled(Grid)`
  &&&& {
    .MuiSnackbarContent-root {
      color: #fff;
      display: flex;
      padding: 6px 16px;
      flex-grow: 1;
      flex-wrap: wrap;
      font-size: 0.875rem;
      align-items: center;
      font-family: Roboto;
      font-weight: 400;
      line-height: 1.43;
    }
    .MuiDropzoneArea-root {
      min-height: 1px !important;
      max-height: 70px;
      border: 1px dashed rgba(0, 117, 201, 0.53);
      border-radius: 8px;
      padding: 0px 10px;
      background-color: #fff;
      margin-bottom: 30px;
      @media (max-width: ${breakpoints.xs}) {
        width: 90%;
      }
    }
    .MuiDropzonePreviewList-removeButton {
      background-color: #fafafb;
      box-shadow: none;
      color: #9ba0ad;
      opacity: 1;
      top: 25px;
      right: 25px;
      left: 420px;
      @media (max-width: ${breakpoints.xs}) {
        left: 240px;
      }
    }
    .MuiDropzonePreviewList-imageContainer {
      text-align: left;
    }
    .MuiDropzoneArea-text {
      color: #9ea4b3;
      font-size: 12px;
      font-weight: 300;
      margin-left: 35px;
      @media (max-width: ${breakpoints.xs}) {
        margin-left: 60px;
        margin-top: 10px;
      }
    }
    .MuiDropzoneArea-icon {
      color: #cfd2da;
      position: relative !important;
      bottom: 60px !important;
      float: left;
      @media (max-width: ${breakpoints.xs}) {
        bottom: 75px !important;
      }
    }
    .MuiTypography-subtitle1 {
      display: none;
    }
  }
`;
